import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReadableStatusPipe } from '../../../pipes/readable-status.pipe';

export type StatusVariant = 'green' | 'blue' | 'amber' | 'red';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [CommonModule, ReadableStatusPipe],
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.css'
})
export class StatusBadgeComponent {
  @Input() status: string = '';
  @Input() customLabel?: string;

  get variant(): StatusVariant {
    const s = (this.status || '').toUpperCase();
    if (s === 'DONE' || s === 'MATCHED_MANUAL') {
      return 'green';
    }
    if (s === 'NEW') {
      return 'blue';
    }
    if (
      s.includes('ERROR') ||
      s.includes('FAILED') ||
      s === 'MISMATCH_MANUAL'
    ) {
      return 'red';
    }
    // Tous les autres statuts ("En cours" : IN_PROGRESS, ON_BUNDLE_CREATION, ON_RECONCILIATION, ON_TRANSFORMATION, TO_RECONCILE, etc.)
    return 'amber';
  }

  get containerClasses(): string {
    const base = 'inline-flex items-center justify-center px-3 py-1 rounded-full text-xs font-semibold border-[1px] border-solid text-nowrap transition-colors min-w-[5.5rem] text-center';
    switch (this.variant) {
      case 'green':
        return `${base} bg-lime-50 text-lime-600 border-lime-200`;
      case 'blue':
        return `${base} bg-blue-100 text-blue-700 border-blue-200`;
      case 'amber':
        return `${base} bg-amber-50 text-amber-800 border-amber-200`;
      case 'red':
        return `${base} bg-red-50 text-red-500 border-red-200`;
    }
  }

  get dotClasses(): string {
    const base = 'w-1.5 h-1.5 rounded-full shrink-0';
    switch (this.variant) {
      case 'green':
        return `${base} bg-lime-600`;
      case 'blue':
        return `${base} bg-blue-600`;
      case 'amber':
        return `${base} bg-amber-600`;
      case 'red':
        return `${base} bg-red-500`;
    }
  }
}
